/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ItemPriceListModel { 
    priceListId?: string | null;
    itemNumber?: string | null;
    itemDescription?: string | null;
    isRandomWeight?: string | null;
    uofm?: string | null;
    inventoryCount?: string | null;
    sellingUOFM?: number;
    isScheduleUOFM?: number;
    pricePerUOFM?: number;
    poNumber?: string | null;
    poDate?: string | null;
    poQuantity?: string | null;
    uOfMAverage?: number | null;
    uOfMAverageMin?: number | null;
    uOfMAverageMax?: number | null;
    readonly uOfMAverageDisplay?: string | null;
}

